"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContribTokenBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
var _ethTypes = require("@blockwell/eth-types");
const settings = [{
  title: "Tokens",
  settings: {
    addresses: {
      type: "var",
      title: "Token Addresses",
      variableType: "value",
      description: "The list of token addresses to show as options.",
      arrayOnly: true,
      default: [_ethTypes.ETH_ADDRESS_ZERO]
    },
    chain: {
      type: "var",
      title: "Chain/Network",
      description: "The chain or network the tokens are on.",
      singleOnly: true,
      default: "mainnet"
    }
  }
}, {
  title: "Variable",
  settings: {
    variable: {
      type: "def",
      title: "Selected Token Variable",
      description: "Name of the variable to save the selected token to.",
      default: {
        name: "token"
      }
    }
  }
}];
class ContribTokenBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "contrib-token");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "addresses", void 0);
    (0, _defineProperty2.default)(this, "chain", void 0);
    (0, _defineProperty2.default)(this, "input", void 0);
    this.param = param;
    this.addresses = this.addBlockParameterVariable("addresses");
    this.chain = this.addBlockParameterVariable("chain");
    this.input = this.addBlockVariablePair(new _variables.WriteableVariable("contract"), param, [], {
      key: "variable",
      default: "token"
    });
  }
  renderValue() {
    return {
      addresses: _variables.vals.stringArray(this.addresses.ref.value()),
      chain: _variables.vals.stringValue(this.chain.ref.value())
    };
  }
  setValue(value) {
    this.input.type.set(value);
  }
}
exports.ContribTokenBlock = ContribTokenBlock;
(0, _defineProperty2.default)(ContribTokenBlock, "settings", settings);
//# sourceMappingURL=ContribTokenBlock.js.map